<template>
  <div class="ym-d-player-component">
    <div id="ym-video-player"
         class="ym-video-d-player"
    ></div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import validator from '@/utils/validator';
  import { PROGRAM_VIDEO_MEDIA_TYPE } from '@/utils/constant';

  export default {
    name: 'YmDPlayer',
    props: {
      audioId: {
        type: Number,
        required: true,
        default: 0,
      },
      id: {
        type: Number,
        required: true,
      },
      type: {
        type: String,
        required: true,
      },
      cover: {
        type: String,
        required: true,
      },
      source: {
        type: String,
        required: true,
      },
      duration: {
        type: String,
        required: true,
      },
      danmaku: {
        validator(val) {
          return validator.isObject(val);
        },
      },
    },
    computed: {
      ...mapGetters([
        'player',
      ]),
      video() {
        const {
          id,
          type,
          duration,
          source,
          cover,
          danmaku,
          audioId,
        } = this;
        return {
          audioId,
          id,
          type,
          duration,
          url: source,
          pic: cover,
          videoType: 'auto',
          mediaType: PROGRAM_VIDEO_MEDIA_TYPE,
          playerMediaType: PROGRAM_VIDEO_MEDIA_TYPE,
          danmaku,
        };
      },
    },
    watch: {
      id() {
        this.playVideo();
      },
      type() {
        this.playVideo();
      },
      cover() {
        this.playVideo();
      },
      source() {
        this.playVideo();
      },
      duration() {
        this.playVideo();
      },
    },
    methods: {
      initPlayer() {
        const { player } = this;
        player.setVideoPlayer({
          container: document.getElementById('ym-video-player'),
        });
      },
      playVideo() {
        const { player, video } = this;
        // 更新播放列表
        player.updatePlaylist([video]);
        // 进行播放
        player.play();
        // 监听事件
        this.setEventListener();
      },
      setEventListener() {
        const { player } = this;

        // 播放结束事件监控
        const nextFn = player.on('videoEnded', () => {
          this.$emit('ended');
        });

        // destroy 实例时解除事件监控
        this.$once('hook:beforeDestroy', () => {
          player.off('canAutoNext', nextFn);
        });
      },
    },
    mounted() {
      this.initPlayer();
      this.playVideo();
    },
  };
</script>
